'use client';

import React from 'react';

import {useMatchMedia} from '@udemy-v2/design-system-utils';
import {useTracker, TrackImpression, generateTrackingId} from '@udemy-v2/event-tracking';
import {useI18n} from '@udemy-v2/i18n';
import {Image} from '@udemy-v2/react-core-components';

import {createDiscoveryItemClickEvent, createDiscoveryImpressionEvent} from '../../data/tracking';
import type {EnrichedSkillCard} from '../../data/types';
import styles from './enriched-skills.module.scss';

interface CardLinkProps {
    card: EnrichedSkillCard;
    index: number;
}

export const CardLink: React.FC<CardLinkProps> = ({card, index}) => {
    const tracker = useTracker();
    const {direction} = useI18n();
    const isMobileMax = useMatchMedia('xs-max');

    return (
        <TrackImpression
            trackFunc={() =>
                tracker.publishEvent(
                    createDiscoveryImpressionEvent({
                        id: index,
                        type: 'course_topic',
                        trackingId: generateTrackingId(),
                        serveTrackingId: '',
                        backendSource: 'discovery',
                        position: index + 1,
                        uiRegion: 'learn_essential_skills',
                    }),
                )
            }
        >
            <a
                href={card.url}
                className={styles.card}
                onClick={() =>
                    tracker.publishEvent(
                        createDiscoveryItemClickEvent({
                            id: index,
                            type: 'course_topic',
                            trackingId: generateTrackingId(),
                            serveTrackingId: '',
                            backendSource: 'discovery',
                            position: index + 1,
                            uiRegion: 'learn_essential_skills',
                        }),
                    )
                }
            >
                <div className={styles['card-image-wrapper']}>
                    <Image
                        src={card.image.url}
                        alt={card.title}
                        className={styles['card-image']}
                        width="unset"
                        height="unset"
                    />
                </div>
                <div className={styles['card-label']}>
                    <span
                        className={`${isMobileMax ? 'ud-text-sm' : 'ud-text-lg'} ${styles['card-label-title']}`}
                    >
                        {card.title}
                    </span>
                    {!isMobileMax && (
                        <span className={styles['card-label-arrow']} aria-hidden="true">
                            {direction === 'rtl' ? <>&larr;</> : <>&rarr;</>}
                        </span>
                    )}
                </div>
            </a>
        </TrackImpression>
    );
};
